module.exports = __webpack_public_path__ + "img/group_remove_opsz20.09711318.svg";